import {
  ArnErc721ANftService,
  Erc721ASearchCriteria,
} from './ArnErc721ANftService';
import {
  ArnDelegateNftService,
  ArnInternalNftService,
} from '../ArnDelegateNftService';
import {
  getJsonRpcProvider,
  ABI_IERC721AQueryable,
  Chains,
  ArnNftMetadata,
  ObjectUtil,
} from '@arianee/arn-types';
import { Contract } from 'ethers';
import { ArnClientError } from '../../ArnClientError';

export class DefaultErc721ANftService
  extends ArnDelegateNftService
  implements ArnErc721ANftService
{
  constructor(nft: ArnInternalNftService) {
    super(nft);
  }

  async getTokenList(searchCriteria: Erc721ASearchCriteria) {
    const contractAddress = ObjectUtil.asSet(
      searchCriteria.contractAddress,
      () => new Error('Contract address expected')
    );
    const userAddress = ObjectUtil.asSet(
      searchCriteria.userAddress ||
        this.service.auth.currentContext?.status.address,
      () => new Error('User address expected')
    );
    const chainId = searchCriteria.chainId || Chains.Ethereum;

    const jsonRpcProvider = getJsonRpcProvider(chainId);
    try {
      const erc721AQueryableContract = new Contract(
        contractAddress,
        ABI_IERC721AQueryable,
        jsonRpcProvider
      );
      const tokenIds = await erc721AQueryableContract.tokensOfOwner(
        userAddress
      );
      const tokenList: Array<ArnNftMetadata> = [];
      for (const tokenId of tokenIds) {
        const token = await this.service.erc721.getToken({
          chainId,
          contractAddress,
          tokenId: tokenId.toNumber(),
        });
        tokenList.push(token);
      }
      return tokenList;
    } catch (err) {
      throw new ArnClientError(
        `Could not fetch tokenURI from contract ${contractAddress}: ${err}`
      );
    }
  }
}
